import React, { useState, useEffect } from 'react';

const DragAndDropB = ({ items, onDrop, render }) => {
  const [localItems, setLocalItems] = useState(items);
  const [draggedItem, setDraggedItem] = useState(null);

  const handleDragStart = (e, item) => {
    e.stopPropagation();
    setDraggedItem(item);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e, targetItem) => {
    e.preventDefault();
    e.stopPropagation();

    if (!draggedItem || !targetItem) return;

    // 같은 부모 내에서만 이동 가능하도록 제한
    if (draggedItem.parents_id !== targetItem.parents_id) {
      alert('같은 상위 카테고리 내에서만 이동 가능합니다.');
      return;
    }

    // 동일 계층 내에서 항목 이동
    const updatedItems = updateHierarchy(localItems, draggedItem, targetItem);

    setLocalItems(updatedItems);
    onDrop(updatedItems); // 부모 컴포넌트로 업데이트 전달
  };

  /**
   * 계층 구조를 업데이트하여 항목 이동 처리
   * @param {Array} items 계층 구조 데이터
   * @param {Object} draggedItem 드래그된 항목
   * @param {Object} targetItem 드롭된 대상 항목
   * @returns {Array} 업데이트된 계층 구조
   */
  const updateHierarchy = (items, draggedItem, targetItem) => {
    // 항목 제거
    const removeItem = (list, itemToRemove) => {
      return list
        .filter((item) => item.key !== itemToRemove.key)
        .map((item) => ({
          ...item,
          children: item.children
            ? removeItem(item.children, itemToRemove)
            : [],
        }));
    };

    // 항목 삽입
    const insertItem = (list, itemToInsert, target) => {
      const updatedList = [];
      let inserted = false;

      const currentIndex = list.findIndex(
        (item) => item.key === itemToInsert.key
      );
      const targetIndex = list.findIndex((item) => item.key === target.key);

      const type = currentIndex > targetIndex ? 'up' : 'down';

      const removeList = removeItem(list, itemToInsert);
      // list.filter((item) => item.key !== itemToInsert.key);

      for (let i = 0; i < removeList.length; i++) {
        const item = removeList[i];

        if (item.key === target.key && type === 'up') {
          // 드롭된 항목 바로 위에 삽입
          updatedList.push(itemToInsert);

          inserted = true;
        }

        updatedList.push(item);

        if (item.key === target.key && type === 'down') {
          // 드롭된 항목 바로 위에 삽입
          updatedList.push(itemToInsert);

          inserted = true;
        }
      }

      if (!inserted) {
        // 만약 드롭된 항목이 맨 아래라면 끝에 삽입
        updatedList.push(itemToInsert);
      }

      return updatedList;
    };

    // 계층적 업데이트 처리
    const updateLevel = (list, itemToInsert, target) => {
      return list.map((item) => {
        if (
          item.key === target.key ||
          (item.children &&
            item.children.some((child) => child.key === target.key))
        ) {
          return {
            ...item,
            children: insertItem(
              // removeItem(item.children || [], itemToInsert),
              item.children,
              itemToInsert,
              target
            ),
          };
        } else if (item.children) {
          return {
            ...item,
            children: updateLevel(item.children, itemToInsert, target),
          };
        }
        return item;
      });
    };

    // 최상위 계층에서 항목 이동 처리
    if (!draggedItem.parents_id) {
      return insertItem(
        // removeItem(items, draggedItem),
        items,
        draggedItem,
        targetItem
      );
    }

    // 하위 계층에서 항목 이동 처리
    return updateLevel(items, draggedItem, targetItem);
  };

  /**
   * 계층 구조 렌더링
   * @param {Array} items 계층 구조 데이터
   * @returns JSX
   */
  const renderItems = (items) => (
    <ul style={{ listStyleType: 'none', padding: 0 }}>
      {items.map((item) => (
        <li
          key={item.key}
          draggable
          onDragStart={(e) => handleDragStart(e, item)}
          onDragOver={handleDragOver}
          onDrop={(e) => handleDrop(e, item)}
          style={{
            margin: '8px 0',
            padding: '8px',
            border: '1px solid #ccc',
            cursor: 'move',
            background: draggedItem?.key === item.key ? '#f0f0f0' : '#fff',
          }}
        >
          {render(item)}
          {item.children && item.children.length > 0 && (
            <div style={{ paddingLeft: 20 }}>{renderItems(item.children)}</div>
          )}
        </li>
      ))}
    </ul>
  );

  useEffect(() => {
    setLocalItems(items);
  }, [items]);

  return renderItems(localItems);
};

export default DragAndDropB;
